<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper/modules";

// CSS ضروري
import "swiper/css";
import "swiper/css/pagination";
</script>

<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الرئيسية</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div
          v-if="isloading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div class="col-md-12" v-if="isloading == false">
          <bannersHome />
        </div>
        <div class="row g-5 g-xl-8">
          <nearLiveV2 />
          <suggestLiveV2 />
          <qbankInfo v-if="isLoggedIn == true && isloading == false" />

          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-wallet"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #1adc004f;
                        color: #16d71d;
                      "
                    ></i>
                    المحفظة</span
                  >
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    رصيدك في المحفظة
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                      <a
                        href="#"
                        class="fs-5 text-gray-800 text-hover-primary fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span v-if="loadingBalance">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </span>
                        <span v-else>{{ walletBalance }} د.ل</span>
                      </a>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        يمكنك شحن محفظتك بوسائل دفع متعددة
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="Wallet" class="btn btn-success btn-sm"
                          >شحن المحفظة <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-play"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #8f9fff63;
                        color: #4a00ce;
                      "
                    ></i>
                    دوراتي
                  </span>
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    الدورات المشترك بها
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                      <a
                        href="#"
                        class="fs-5 text-gray-800 text-hover-primary fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span v-if="loadingCourses">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </span>
                        <span v-else>{{ courseCount }}</span>
                      </a>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        تصفح هنا الدورات المشترك بها
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="Dashboard" class="btn btn-success btn-sm"
                          >عرض <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-desktop"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #b4ffc5;
                        color: #000000;
                      "
                    ></i>
                    الجلسات الخاصة
                  </span>
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    الجلسات والدروس الخاصة
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div class="symbol flex-shrink-0 me-4">
                    <img
                      src="assets/img/webinar.png"
                      class="mw-100"
                      style="height: 80px; width: 85px"
                      alt=""
                    />
                  </div>
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                      <a
                        href="#"
                        class="fs-5 text-gray-800 text-hover-primary fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span>الجلسات الخاصة</span>
                      </a>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        تصفح هنا الجلسات الخاصة
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="prvs" class="btn btn-success btn-sm"
                          >عرض <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
          <div class="col-xl-4" v-if="isLoggedIn == true && isloading == false">
            <div class="card card-xl-stretch mb-5 mb-xl-8">
              <!-- Header -->
              <div class="card-header align-items-center border-0 mt-3">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark fs-3">
                    <i
                      class="fas fa-university"
                      style="
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #cfffda;
                        color: #00a625;
                      "
                    ></i>
                    بنك الأسئلة
                  </span>
                  <small class="text-gray-400 mt-2 fw-semibold fs-6">
                    مجموعة متنوعة ومتعددة من الأسئلة
                  </small>
                </h3>
              </div>

              <!-- Body -->
              <div class="card-body pt-5">
                <div class="d-flex mb-7">
                  <div class="symbol flex-shrink-0 me-4">
                    <img
                      src="assets/img/galaxy.png"
                      class="mw-100"
                      style="height: 80px; width: 85px"
                      alt=""
                    />
                  </div>
                  <div
                    class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1"
                  >
                    <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                      <a
                        href="#"
                        class="fs-5 text-gray-800 text-hover-primary fw-bold"
                        style="font-weight: 700 !important"
                      >
                        <span> بنك الأسئلة</span>
                      </a>
                      <span class="text-gray-400 fw-semibold fs-7 my-1">
                        أسئلة متنوعة في في معظم التخصصات
                      </span>
                    </div>
                    <div class="text-end py-lg-0 py-2">
                      <span class="text-gray-400 fs-7 fw-semibold d-block">
                        <a href="qbank" class="btn btn-success btn-sm"
                          >عرض <i class="fa fa-arrow-left"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Slide 2 -->
              </div>
            </div>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-md-12" v-if="isloading == false && isLoggedIn == false">
            <infoDetails />
          </div>
          <div class="col-md-12" v-if="isloading == false">
            <h3 class="text-center section-title">أبرز التخصصات</h3>
          </div>
          <div
            v-if="isloading == false"
            class="col-md-6 col-xxl-3 mt-2 section-cats"
            v-for="(category, index) in categories"
            :key="'category-' + index"
          >
            <!--begin::Card-->
            <div class="card">
              <!--begin::Card body-->
              <div class="card-body d-flex flex-center flex-column p-9">
                <!--begin::Wrapper-->
                <div class="mb-5">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-75px">
                    <a @click.prevent="openModal(category.subcategory)">
                      <img
                        :src="
                          category.cat_image
                            ? `${catImagePath}${category.cat_image}`
                            : defaultImage
                        "
                        @error="handleImageError"
                        :data-category-id="category.id"
                        :alt="category.name"
                      />
                    </a>
                  </div>
                  <!--end::Avatar-->
                </div>
                <!--end::Wrapper-->
                <!--begin::Name-->
                <a
                  href="#"
                  @click.prevent="openModal(category.subcategory)"
                  class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0"
                >
                  {{ category.title.en }}
                </a>

                <!--end::Name-->
                <!--begin::Position-->
                <div class="fw-semibold text-gray-400 mb-6">
                  {{ category.description || "تخصصات أكاديميا" }}
                </div>
                <!--end::Position-->
                <!--begin::Link-->
                <!--<a :href="`/CategoryCourses?value_id=category_id&value=${category.id}`"
                  class="btn btn-sm btn-light-success fw-bold">
                  عرض <i class="fa fa-arrow-left"></i>
                </a>-->
                <!--end::Link-->
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
          <!--begin::Col-->
          <div class="col-sm-12 support" v-if="isloading == false">
            <!--begin::Address-->
            <div
              class="text-center bg-light card-rounded d-flex flex-column justify-content-center p-10 h-100"
            >
              <!--begin::Icon-->
              <!--begin::Svg Icon | path: icons/duotune/general/gen018.svg-->
              <span class="svg-icon svg-icon-3tx svg-icon-primary">
                <i class="bi bi-telegram"></i>
              </span>
              <!--end::Svg Icon-->
              <!--end::Icon-->
              <!--begin::Subtitle-->
              <h1 class="text-dark fw-bold my-5">الدعم الفني</h1>
              <!--end::Subtitle-->
              <!--begin::Description-->
              <div class="text-gray-700 fs-3 fw-semibold">
                <a href="https://t.me/aca_demia" target="_blank">
                  0913103064 ( تليغرام)</a
                >
              </div>
              <!--end::Description-->
            </div>
            <!--end::Address-->
          </div>
          <!--end::Col-->
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->
  </div>
  <!-- هيكل المودال -->
  <div
    class="modal fade"
    id="subCatsModal"
    tabindex="-1"
    aria-labelledby="subCatsModalLabel"
    aria-hidden="true"
    ref="subCatsModal"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- عنوان المودال -->
        <div class="modal-header">
          <h5 class="modal-title" id="subCatsModalLabel">التخصصات</h5>
          <button
            type="button"
            class="btn-close"
            @click="closeModal"
            aria-label="إغلاق"
          ></button>
        </div>
        <!-- محتوى المودال -->
        <div class="modal-body" ref="subCatContent">
          <!-- المحتوى سيتم ملؤه هنا -->
        </div>
        <!-- تذييل المودال (اختياري) -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import infoDetails from "./infoDetails.vue";
import bannersHome from "./banners.vue";
import qbankInfo from "./qbankInfo.vue";
import nearLiveV2 from "./nearLiveV2.vue";
import nearSession from "./nearSession.vue";

import suggestLiveV2 from "./suggestLiveV2.vue";

export default {
  name: "Home",
  components: {
    infoDetails,
    nearLiveV2,
    qbankInfo,
    suggestLiveV2,
    bannersHome,
    nearSession,
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      isloading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      walletBalance: 0,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      mobile: "0",
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      loadingBalance: true, // Loading state for wallet balance
      tab: "nearLive", // لتحديد التاب النشط
      nearLiveStreams: [], // بيانات التاب الأول
      suggestLiveStreams: [], // بيانات التاب الثاني
    };
  },
  computed: {
    activeTab() {
      if (this.nearLiveStreams.length > 0) return "near";
      if (this.suggestLiveStreams.length > 0) return "suggest";
      return "near"; // لو كلاهما فاضيين نعرض الأول كخيار افتراضي
    },
  },
  watch: {
    isloading(newVal) {
      if (newVal === false) {
        // DOM جاهز لتهيئة Flickity
      }
    },
  },
  mounted() {
    this.fetchCategories();
    this.fetchStudentDetails();
    this.getBalance();
  },
  methods: {
    openModal(subCategories) {
      // بناء محتوى المودال على شكل بطاقات مع روابط
      const cardHTML = subCategories
        .map(
          (subCategory) => `
    <div class="col-md-4 col-sm-6 mb-4">
      <div class="card text-center" style="color: #fff;cursor: pointer;background: #113954;" onclick="location.href='/CategoryCourses?value_id=subcategory_id&value=${subCategory.id}'">
        <div class="card-body">
          <h5 class="card-title" style="font-size:13px">${subCategory.title}</h5>
        </div>
      </div>
    </div>
  `
        )
        .join("");

      // إضافة البطاقات إلى صف
      this.$refs.subCatContent.innerHTML = `
    <div class="row">
      ${cardHTML}
    </div>
  `;

      // فتح المودال باستخدام Bootstrap
      const modalElement = new bootstrap.Modal(this.$refs.subCatsModal);
      modalElement.show();
    },
    closeModal() {
      // إغلاق المودال
      const modalElement = bootstrap.Modal.getInstance(this.$refs.subCatsModal);
      if (modalElement) {
        modalElement.hide();
      }
    },
    async fetchCategories() {
      this.loadingCategories = true; // Start loading
      try {
        const response = await fetch(`${apiUrl}/home/web?d=s`, {
          method: "GET",
          headers: {
            "x-country-code": "+218",
          },
        });

        const jsonResponse = await response.json();
        this.categories = jsonResponse.allcategory;
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        this.loadingCategories = false; // Stop loading
      }
    },

    async fetchStudentDetails() {
      this.loadingCourses = true; // Start loading
      try {
        const response = await fetch(`${apiUrl}/desktop/my-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
            "x-country-code": "LY",
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.student = data.student;
          this.mobile = data.student.mobile;
          this.courseCount = data.courses.length;
          this.isLoggedIn = true;
          this.isloading = false;
        } else if (response.status === 401 || response.status === 403) {
          //this.$router.push("/logout");
          this.isloading = false;
        } else {
          console.error("Failed to fetch student details");
          this.isloading = false;
        }
        this.isloading = false;
      } catch (error) {
        console.error("Error fetching student details:", error);
        //this.$router.push("/logout");
      } finally {
        this.loadingCourses = false; // Stop loading
      }
    },
    async getBalance() {
      this.loadingBalance = true; // Start loading
      try {
        const response = await fetch(
          `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
              "x-country-code": "LY",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.walletBalance = data.wallet_balance;
          this.isloading = false;
        } else {
          console.error("Failed to fetch balance");
          this.isloading = false;
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
        this.loadingBalance = false; // Stop loading
        this.isloading = false;
      }
    },
    async getNearLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(`${apiUrl}/livestream/get-near-live-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
            "x-country-code": "LY",
          },
        });

        if (response.ok) {
          this.nearLiveStreams = await response.json();
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    async getsuggestLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(`${apiUrl}/livestream/get-similar-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
            "x-country-code": "LY",
          },
        });

        if (response.ok) {
          this.suggestLiveStreams = await response.json();
          console.log(this.suggestLiveStreams.length);
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    handleImageError(event) {
      // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
      event.target.src = this.defaultImage;
    },
  },
};
</script>

<style scoped>
/* نقاط السلايدر */
.mySwiper {
  width: 100%;
}

.swiper-pagination {
  bottom: 0px !important;
}

.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: #999;
  opacity: 0.7;
}

.swiper-pagination-bullet-active {
  background: #0d6efd; /* اللون الأساسي */
  opacity: 1;
}
.btn-success {
  background-color: #0fc438 !important;
}
</style>
